import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import CleApiService from "@/integrations/service/cle-api.service";

const CLE = ["cles-api"];

export const useClesApi = () =>
  useQuery({ queryKey: CLE, queryFn: CleApiService.lister });

export const useCreerCleApi = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: CleApiService.creer,
    onSuccess: () => qc.invalidateQueries({ queryKey: CLE }),
  });
};

export const useRevoquerCleApi = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: CleApiService.revoquer,
    onSuccess: () => qc.invalidateQueries({ queryKey: CLE }),
  });
};
